import type { ComponentProps } from 'react';

import * as THREE from 'three';

import { Camera, IntrinsicCamera, type VisualizationAxis } from '@elva-visualizer';

type SwingGuideCameraProps = {
    axis: VisualizationAxis;
    cameraParams: ComponentProps<typeof IntrinsicCamera>['params'] | null;
    targetPoint: THREE.Vector3 | null;
};

export const SwingGuideCamera = ({ axis, cameraParams, targetPoint }: SwingGuideCameraProps) => {
    const staticCamera = axis.camera.type === 'static' ? axis.camera : undefined;

    if (cameraParams) {
        return <IntrinsicCamera params={cameraParams} transitionDuration={0} enableZoom={false} />;
    }

    return (
        <Camera
            target={targetPoint ?? undefined}
            forcedAzimuthalAngle={staticCamera?.azimuthal ?? null}
            forcedPolarAngle={staticCamera?.polar ?? null}
            enablePan={false}
            enableZoom={false}
            targetTransitionDuration={0}
        />
    );
};
